import {Nullable} from '../../util/type-helper';

export interface ParsedJwtToken {
  name: string;
  roles: string[];
  /** e/u-nummber fuer Support User, ciso[ti]XXX fuer normale User */
  sbbuid?: string;
  preferred_username: string;
  sub: string;
  exp: number;
  iat: number;
  oid?: string;
}

export function decodeJwt<T>(encodedJwt: Nullable<string>): T {
  const payloadBase64 = encodedJwt?.split('.')?.[1];
  if (!payloadBase64) {
    throw new Error('Invalid Token: ' + encodedJwt);
  }
  return JSON.parse(decodeBase64Unicode(payloadBase64));
}

function decodeBase64Unicode(base64: string): string {
  const binString = atob(base64);
  const arrayLike = binString.split('').map(m => m.codePointAt(0)!);
  const uint8Array = Uint8Array.from(arrayLike);
  return new TextDecoder().decode(uint8Array);
}
